"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityInterestDto = instanceOfFacilityInterestDto;
exports.FacilityInterestDtoFromJSON = FacilityInterestDtoFromJSON;
exports.FacilityInterestDtoFromJSONTyped = FacilityInterestDtoFromJSONTyped;
exports.FacilityInterestDtoToJSON = FacilityInterestDtoToJSON;
exports.FacilityInterestDtoToJSONTyped = FacilityInterestDtoToJSONTyped;
const TravelWillingness_1 = require("./TravelWillingness");
const WorkTypePreference_1 = require("./WorkTypePreference");
/**
 * Check if a given object implements the FacilityInterestDto interface.
 */
function instanceOfFacilityInterestDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('workTypePreference' in value) || value['workTypePreference'] === undefined)
        return false;
    if (!('willingToTravel' in value) || value['willingToTravel'] === undefined)
        return false;
    if (!('specialtyCodes' in value) || value['specialtyCodes'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function FacilityInterestDtoFromJSON(json) {
    return FacilityInterestDtoFromJSONTyped(json, false);
}
function FacilityInterestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'facilityId': json['facilityId'],
        'nurseProfileId': json['nurseProfileId'],
        'workTypePreference': (0, WorkTypePreference_1.WorkTypePreferenceFromJSON)(json['workTypePreference']),
        'willingToTravel': (0, TravelWillingness_1.TravelWillingnessFromJSON)(json['willingToTravel']),
        'specialtyCodes': json['specialtyCodes'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'startDateComment': json['startDateComment'] == null ? undefined : json['startDateComment'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function FacilityInterestDtoToJSON(json) {
    return FacilityInterestDtoToJSONTyped(json, false);
}
function FacilityInterestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'facilityId': value['facilityId'],
        'nurseProfileId': value['nurseProfileId'],
        'workTypePreference': (0, WorkTypePreference_1.WorkTypePreferenceToJSON)(value['workTypePreference']),
        'willingToTravel': (0, TravelWillingness_1.TravelWillingnessToJSON)(value['willingToTravel']),
        'specialtyCodes': value['specialtyCodes'],
        'comment': value['comment'],
        'startDateComment': value['startDateComment'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}
//# sourceMappingURL=FacilityInterestDto.js.map